//export class RequisitionGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionForm = new RequisitionForm();
//};

//export class RequisitionListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionList = new  RequisitionList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RequisitionBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionGeneratedForm}];
//};

//export class RequisitionListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public date: IFieldOptions = { field: "date" };
	public uniqueId: IFieldOptions = { field: "uniqueId" };
	public deliveryAddress: IFieldOptions = { field: "deliveryAddress" };
	public contactPerson: IFieldOptions = { field: "contactPerson" };
	public contactNumber: IFieldOptions = { field: "contactNumber" };
	public latestRequisitionWorkflowId: IFieldOptions = { field: "latestRequisitionWorkflowId" };
	public organisationId: IFieldOptions = { field: "organisationId" };
	public createdByUserId: IFieldOptions = { field: "createdByUserId" };
	public isStore: IFieldOptions = { field: "isStore" };
  public warehouseId: IFieldOptions = { field: "warehouseId" };
  public isPettyCash: IFieldOptions = { field: "isPettyCash" };
  public poComments: IFieldOptions = { field: "poComments" };
  public isReservationOrder: IFieldOptions = { field: "isReservationOrder" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.date);
		this.push(this.uniqueId);
		this.push(this.deliveryAddress);
		this.push(this.contactPerson);
		this.push(this.contactNumber);
		this.push(this.latestRequisitionWorkflowId);
		this.push(this.organisationId);
		this.push(this.createdByUserId);
    this.push(this.isStore);
    this.push(this.isReservationOrder);
      this.push(this.warehouseId);
    this.push(this.isPettyCash);
    this.push(this.poComments);
	}
}

export class RequisitionForm implements IFormOptions {
	protected requisitionFormName: string = "requisitionForm";
	protected requisitionFormModel: models.RequisitionDTO = new models.RequisitionDTO();
	protected requisitionFormEndPoints: RequisitionEndPoints = new RequisitionEndPoints();
	protected requisitionFormFields: RequisitionFormFields = new RequisitionFormFields();
	public get name(): string { return this.requisitionFormName };
	public get model(): models.RequisitionDTO { return this.requisitionFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionFormEndPoints };
       public set endPoints(requisitionEndPoints: IEntityEndPoints) {
		this.requisitionFormEndPoints = requisitionEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionFormFields { return this.requisitionFormFields };
}

export class RequisitionListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public date: IColumnOptions = { field: "date", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public uniqueId: IColumnOptions = { field: "uniqueId" };
	public deliveryAddress: IColumnOptions = { field: "deliveryAddress" };
	public contactPerson: IColumnOptions = { field: "contactPerson" };
	public contactNumber: IColumnOptions = { field: "contactNumber" };
	public latestRequisitionWorkflowId: IColumnOptions = { field: "latestRequisitionWorkflowId" };
	public organisationId: IColumnOptions = { field: "organisationId" };
	public createdByUserId: IColumnOptions = { field: "createdByUserId" };
	public isStore: IColumnOptions = { field: "isStore" };
  public warehouseId: IColumnOptions = { field: "warehouseId" };
  public isPettyCash: IFieldOptions = { field: "isPettyCash" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.date);
		this.push(this.uniqueId);
		this.push(this.deliveryAddress);
		this.push(this.contactPerson);
		this.push(this.contactNumber);
		this.push(this.latestRequisitionWorkflowId);
		this.push(this.organisationId);
		this.push(this.createdByUserId);
		this.push(this.isStore);
      this.push(this.warehouseId);
      this.push(this.isPettyCash);
	}
}

export class RequisitionList implements IGridOptions {
	protected requisitionListName: string = "requisitionList";
	protected requisitionListModel: models.RequisitionDTO = new models.RequisitionDTO();
	protected requisitionListEndPoints: RequisitionEndPoints = new RequisitionEndPoints();
	protected requisitionListColumns: RequisitionListColumns = new RequisitionListColumns();
	public requisitionForm: RequisitionForm = new RequisitionForm();
	public get name(): string { return this.requisitionListName };
	public get model(): models.RequisitionDTO { return this.requisitionListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionListEndPoints };
	public set endPoints(requisitionEndPoints: IEntityEndPoints) {
		this.requisitionListEndPoints = requisitionEndPoints;
		this.requisitionForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionListColumns { return this.requisitionListColumns };
}

export class RequisitionEntity implements IEntityOptions {
	protected requisitionEntityName: string = "requisitionEntity";
	protected requisitionEntityModel: models.RequisitionDTO = new models.RequisitionDTO();
	protected requisitionEntityEndPoints: RequisitionEndPoints = new RequisitionEndPoints();
	protected requisitionEntityList: RequisitionList = new RequisitionList();
	public get name(): string { return this.requisitionEntityName };
	public get model(): models.RequisitionDTO { return this.requisitionEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionEntityEndPoints };
	public set endPoints(requisitionEndPoints: IEntityEndPoints) {
		this.requisitionEntityEndPoints = requisitionEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionList { return this.requisitionEntityList };
	public get form(): RequisitionForm { return this.grid.requisitionForm };
	constructor(name?: string) {
		if (name) this.requisitionEntityName = name;
		this.endPoints = this.requisitionEntityEndPoints;
	}
};
